// @ts-expect-error i18n
import i18nResourcesPrompt from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/survey/BaseQuestion.json!config/locales_i18next/index.js';
import styled from 'astroturf/react';
import addResources from 'js/i18next/addResources';
import useTranslationTest from 'js/utils/hooks/useTranslationTest';
import { Fragment, useEffect } from 'react';
import { SurveyQuestion, SurveyQuestionPrompt } from './styles/QuestionStyles';
import { QuestionType, UserTaggingQuestion } from './types';

const PROMPT_TRANSLATION_NAMESPACE = 'RegPath.SignupToDownload.BaseQuestion';
addResources(i18nResourcesPrompt, PROMPT_TRANSLATION_NAMESPACE);

interface Props {
  question: UserTaggingQuestion & { questionType: QuestionType.Freeform };
  setQuestionLoadTime: () => void;
  maxAnswers?: number;
  answers: string[];
  updateAnswer(i: number, answer: string): void;
  numbered?: boolean;
  dynamic?: boolean;
}

const FreeformInput = styled.input`
  /* Monochromatic/White */
  background: #ffffff;
  /* Monochromatic/Gray Light */
  border: 1px solid #dddde2;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 14px 16px;
`;

const Subprompt = styled.div`
  margin-bottom: 16px;
`;

const AnswersContainer = styled.div<{ labeled: boolean }>`
  font-size: 16px;
  display: grid;
  row-gap: 8px;
  column-gap: 12px;
  align-items: center;
  margin-bottom: 8px;

  &.labeled {
    grid-template-columns: min-content auto;
  }
`;

const FreeformQuestion: React.FC<Props> = ({
  question,
  setQuestionLoadTime,
  answers,
  updateAnswer,
  numbered = false,
  dynamic = false,
}) => {
  const { prompt, subprompt } = question;
  const [tPrompt] = useTranslationTest(PROMPT_TRANSLATION_NAMESPACE, true);
  useEffect(setQuestionLoadTime, [setQuestionLoadTime]);
  return (
    <SurveyQuestion>
      <SurveyQuestionPrompt>{tPrompt(prompt)}</SurveyQuestionPrompt>
      {subprompt && <Subprompt>{tPrompt(subprompt)}</Subprompt>}
      <AnswersContainer labeled={numbered}>
        {answers.map((a, i) => (
          <Fragment key={i}>
            {numbered && <div>{i + 1}.</div>}
            {(!dynamic ||
              (dynamic && (i === 0 || answers[i - 1]?.length > 0))) && (
              <FreeformInput
                value={a}
                placeholder={
                  dynamic && i > 0
                    ? tPrompt('optionalAnotherTopic')
                    : tPrompt('specificTopic')
                }
                onChange={(event) => {
                  updateAnswer(i, event.target.value);
                }}
              />
            )}
          </Fragment>
        ))}
      </AnswersContainer>
    </SurveyQuestion>
  );
};

export default FreeformQuestion;
